export function setupCourseBox() {
  const courseBoxes = document.querySelectorAll('a.coursebox-container.course');
  if (courseBoxes.length > 0) {

    let separators = document.querySelectorAll('a.coursebox-container.course[data-tags*="separator"]');
    if (separators.length > 0) {
      separators.forEach((item) => {
        item.innerHTML = item.innerHTML.replace('[separator]', '');
      })
    }

    courseBoxes.forEach((course) => {
      if (!course.querySelector('.as-coursebox-content')) {
        let courseBoxContent = course.innerHTML;
        let wrappedCourseBoxcontent = `<div class="as-coursebox-content">${courseBoxContent}</div>`
        course.innerHTML = wrappedCourseBoxcontent;

        let courseCount = course.querySelector('.course-series-count') ? course.querySelector('.course-series-count').innerText.trim() : "";
        let courseTags = course.getAttribute('data-tags') || "";
        let courseDifficulty = courseTags && ((courseTags.includes('advanced') && "Advanced") || (courseTags.includes('intermediate') && "Intermediate") || (courseTags.includes('beginner') && "Beginner") || "");
        let courseCost = course.querySelector(".storefront-price span") ? course.querySelector(".storefront-price span").innerText.trim() : "";
        let courseTime = course.querySelector(".course-time span") ? course.querySelector(".course-time span").innerText.trim() : "";

        let courseMeta = document.createElement('div');
        courseMeta.classList.add('as-coursebox__meta')
        courseMeta.innerHTML = `  
        <div class="as-coursebox__meta-tags as-flex-container">
          ${courseDifficulty ? `
            <div class="as-coursebox__meta-difficulty as-tag">
              ${courseDifficulty}
            </div>
          ` : ""}
  
          ${courseCost ? `
            <div class="as-coursebox__meta-cost as-tag as-tag-filled">
              ${courseCost}
            </div>
          ` : ""}
        </div>

        ${courseCount ? `
          <div class="as-coursebox__meta-count">
            ${courseCount}
          </div>
        ` : ""}

        ${courseTime ? `
        <div class="as-coursebox__meta-time">
          ${courseTime}
        </div>
      ` : ""}
  
        ${course.dataset.course === "astronomer-certified-apache-airflow-core-exam" ? `
        <div class="as-coursebox__meta-study-guide as-tag">
          <a href="https://www.astronomer.io/uploads/Apache-Airflow-Fundamentals-Study-Guide.pdf" target="_blank">Study Guide</a>
        </div>
      ` : ""}
      `;

        course.append(courseMeta);
      }
    })
  }
}